import { status } from 'skin/event/status';

const def = (obj, table, story, d, action) => {
	console.log('[def таблица] событие', obj);
	return status.action;
};
export default def;
